import React, { useEffect, useState } from 'react';
import TableDataLayer from "../components/TableDataLayer";
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { apiCall } from "../utils/apiService";
import moment from 'moment-timezone';
import { NavLink } from 'react-router-dom';
import ToggleBar from "./child/ToggleBar";
import PlanLockedBanner from "./PlanLockedBanner";
import { getPlanFeatures } from "../utils/planFeatures";
import "./ListPage.css";

const readPlanFeatures = () => {
    try {
        const user = JSON.parse(localStorage.getItem("user") || "null");
        return getPlanFeatures(user);
    } catch {
        return getPlanFeatures(null);
    }
};

const CampaignLayer = () => {
    const defaultSystemTimezone = moment.tz.guess();
    const defaultLocalDatetime = moment().format("YYYY-MM-DDTHH:mm");

    const [instances, setInstances] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [phonebooks, setPhonebooks] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [timeZones, setTimeZones] = useState([]);
    const [alertMessage, setAlertMessage] = useState('');
    const [usingTemplate, setUsingTemplate] = useState(true);
    const [selectedInstance, setSelectedInstance] = useState([]);
    const [instanceObject, setInstanceObject] = useState([]);
    const [data, setData] = useState();
    const [planFeatures, setPlanFeatures] = useState(() => readPlanFeatures());
    const canSchedule = !!planFeatures.schedule;
    const canBulk = !!planFeatures.bulk;
    const [campaign, setCampaign] = useState({
        campaignName: "",
        client_id: [{ id: "", uid: "" }],
        dialog: true,
        phoneBookName: "",
        randomDelayFrom: null,
        randomDelayTo: null,
        schedule: false,
        scheduleTimestamp: defaultLocalDatetime,
        sending_type: "",
        templetID: null,
        typedMsg: "",
        timezone: defaultSystemTimezone,
        fromTemplet: true,
    });

    const fetchCampaigns = async () => {
        try {
            const response = await apiCall({
                url: `bulk_campaign/get_mine`,
                method: 'Get',
            });
            setData(response.total)
            // setCampaigns(response.data);
            return response
        } catch (error) {
            console.error('Error fetching campaigns:', error);
        }
    };

    const fetchInstances = async () => {
        try {
            const response = await apiCall({
                url: `sessions/get-users-instances`,
                method: 'GET',
            });
            setInstances(response.data);
        } catch (error) {
            console.error('Error fetching instances:', error);
        }
    };

    const fetchPhonebooks = async () => {
        try {
            const response = await apiCall({
                url: `phonebook/get-phonebook`,
                method: 'GET',
            });
            setPhonebooks(response.data);
        } catch (error) {
            console.error('Error fetching instances:', error);
        }
    };

    const fetchTemplates = async () => {
        try {
            const response = await apiCall({
                url: `templet/get-templet`,
                method: 'POST',
                body: { type: 'all' }
            });
            setTemplates(response.data);
        } catch (error) {
            console.error('Error fetching templates:', error);
        }
    };

    const removeCampaign = async (id) => {
        try {
            const response = await apiCall({
                url: `bulk_campaign/del_campaign`,
                method: 'POST',
                body: { campaign_id: id }
            });
            if (response.success) {
                // fetchCampaigns();
                // window.location.reload();
                setData(data - 1);
            }
        } catch (error) {
            console.error('Error fetching campaign:', error);
        }
    };


    // handle using instance select all
    const handleSelectAllInstance = () => {
        if (!selectAll) {
            const selectedValues = [];
            const selectedObject = [];
            instances.forEach((instance) => {
                selectedValues.push(instance.client_id);
                selectedObject.push({ id: instance.id, uid: instance.client_id });
            });
            setInstanceObject(selectedObject);
            setSelectedInstance(selectedValues);
            setCampaign({ ...campaign, client_id: selectedObject })
        } else {
            setInstanceObject([]);
            setSelectedInstance([]);
        }
        setSelectAll(!selectAll);
    };

    // Function to filter instances based on ID
    const filterInstancesById = (id) => {
        // Filter instances based on the target ID
        const filteredInstances = instances.filter(instance => instance.client_id === id);

        if (filteredInstances.length > 0) {
            // If there's a match, return the is_active value of the first matched instance
            return filteredInstances[0];
        } else {
            // If no match is found, return false (or any default value you prefer)
            return false;
        }
    };

    // handle to selected instance
    const handleSelectInstance = (clientId) => {
        const isSelected = selectedInstance.includes(clientId);
        let updatedSelected = [];
        let updatedObject = [];

        if (isSelected) {
            // Remove if already selected
            updatedSelected = selectedInstance.filter((id) => id !== clientId);
            updatedObject = instanceObject.filter((obj) => obj.uid !== clientId);
        } else {
            // Add new selection
            updatedSelected = [...selectedInstance, clientId];
            const instance = filterInstancesById(clientId);
            updatedObject = [...instanceObject, { id: instance.id, uid: instance.client_id }];
        }

        setSelectedInstance(updatedSelected);
        setInstanceObject(updatedObject);
        setCampaign({ ...campaign, client_id: updatedObject });
    };


    // create new campaign
    const handleCampaignSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        const { isValid, messageText } = validated();
        if (isValid) {
            try {
                const scheduleEnabled = !!campaign.schedule && canSchedule;
                if (scheduleEnabled && !campaign.scheduleTimestamp) {
                    setAlertMessage({ message: "Please choose a schedule date and time", class: "danger" });
                    hideAlert();
                    return;
                }
                const payload = {
                    ...campaign,
                    schedule: scheduleEnabled,
                    scheduleTimestamp: scheduleEnabled
                        ? moment
                              .tz(campaign.scheduleTimestamp, "YYYY-MM-DDTHH:mm", campaign.timezone || defaultSystemTimezone)
                              .toISOString()
                        : moment().toISOString(),
                    timezone: campaign.timezone || defaultSystemTimezone,
                };
                const response = await apiCall({
                    url: `bulk_campaign/add_campaign`,
                    method: 'POST',
                    body: payload,
                });

                if (response.success) {
                    setAlertMessage({ message: response.msg, class: 'success' });
                    addNewCampaign(response.data);
                    cleanForm();
                    setData(data + 1);
                } else {
                    setAlertMessage({ message: response.msg, class: 'danger' });
                }

            } catch (error) {
                document.getElementById('close-btn')?.click();
                setAlertMessage({ message: error.message, class: 'danger' });
                console.error('Campaign error:', error);
            }
        } else {
            setAlertMessage({ message: messageText, class: 'danger' });
            hideAlert();
        }
    };

    // validate form
    const validated = () => {
        if (campaign.campaignName == '') {
            return { isValid: false, messageText: 'Campaign title is required!' };
        } else if (instanceObject.length == 0) {
            return { isValid: false, messageText: 'Instance is required!' };
            // } else if (campaign.randomDelayFrom == null) {
            //     return { isValid: false, messageText: 'Delay from is required!' };
        } else if (campaign.randomDelayTo == null) {
            return { isValid: false, messageText: 'Delay to is required!' };
        } else if (!usingTemplate && campaign.message == '') {
            return { isValid: false, messageText: 'Message is required!' };
        } else if (campaign.phoneBookName == '') {
            return { isValid: false, messageText: 'Phonebook is required!' };
        }
        return { isValid: true, messageText: '' }
    }

    // clean from after submission
    const cleanForm = () => {
        setCampaign({
            campaignName: "",
            client_id: [{ id: "", uid: "" }],
            dialog: true,
            phoneBookName: "",
            randomDelayFrom: null,
            randomDelayTo: null,
            schedule: false,
            scheduleTimestamp: moment().format("YYYY-MM-DDTHH:mm"),
            sending_type: "",
            templetID: null,
            timezone: defaultSystemTimezone,
            fromTemplet: true
        });
        hideAlert();
    }

    const hideAlert = () => {
        setTimeout(() => {
            setAlertMessage('');
        }, 3000);
    }

    const addNewCampaign = (newCampaign) => {
        setCampaigns([newCampaign, ...campaigns]);
    };

    // handle using template
    const handleUsingTemplate = () => {
        setCampaign({ ...campaign, sending_type: "templet" })
        setUsingTemplate(!usingTemplate);
    };

    const columns = [
        { key: 'id', label: 'ID' },
        {
            key: 'title',
            label: 'Name',
            render: (val) => <span className="fw-semibold">{val || "Untitled"}</span>,
        },
        { key: 'templet_id', label: 'Template' },
        {
            key: 'phonebook_name',
            label: 'Phonebook',
            render: (val) => (
                <span className="list-chip" style={{ padding: "4px 10px" }}>{val || "—"}</span>
            ),
        },
        {
            key: 'status',
            label: 'Status',
            render: (val, row) => (
                <span className={`list-status ${row.status == 1 ? "success" : "secondary"}`}>
                    {row.status == 1 ? "Active" : "Inactive"}
                </span>
            ),
        },
        {
            key: 'createdAt',
            label: 'Created',
            render: (val, row) => {
                const date = new Date(row.createdAt);
                if (Number.isNaN(date.getTime())) return "—";
                return date.toLocaleDateString(undefined, {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                });
            },
        },
        {
            key: 'actions',
            label: 'Actions',
            render: (val, row) => (
                <>
                    <Link
                        to={`/campaigns/${row.campaign_id}/logs`}
                        title="View logs"
                        className="w-32-px h-32-px me-8 bg-info-focus text-info-main rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                        <Icon icon="mingcute:eye-2-line" />
                    </Link>
                    <button
                        type="button"
                        title="Delete campaign"
                        onClick={() => removeCampaign(row.campaign_id)}
                        className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center border-0"
                    >
                        <Icon icon="mingcute:delete-2-line" />
                    </button>
                </>
            ),
        },
    ];

    useEffect(() => {
        document.title = "Campaign List";
        setTimeZones(moment.tz.names());
        setPlanFeatures(readPlanFeatures());
        fetchInstances();
        fetchPhonebooks();
        fetchTemplates();
        (async () => {
            try {
                const res = await apiCall({ url: "user/get-user-by-token", method: "GET" });
                if (res?.success && res.data) {
                    localStorage.setItem("user", JSON.stringify(res.data));
                    setPlanFeatures(getPlanFeatures(res.data));
                }
            } catch {
                /* keep cached plan flags */
            }
        })();
    }, [])

    return (
        <>
            {!canBulk ? (
                <PlanLockedBanner
                    title="Campaigns not in your plan"
                    message="Bulk / campaign messaging requires a plan that includes this feature."
                />
            ) : null}
            <div className="list-kpi-row">
                <div className="card list-kpi campaigns">
                    <div className="list-kpi-body">
                        <div>
                            <p className="list-kpi-label">Campaigns</p>
                            <h6 className="list-kpi-value">{Number(data) || 0}</h6>
                        </div>
                        <div className="list-kpi-icon"><Icon icon="mdi:bullhorn-outline" /></div>
                    </div>
                </div>
                <div className="card list-kpi books">
                    <div className="list-kpi-body">
                        <div>
                            <p className="list-kpi-label">Sessions</p>
                            <h6 className="list-kpi-value">{instances.length}</h6>
                        </div>
                        <div className="list-kpi-icon"><Icon icon="mdi:whatsapp" /></div>
                    </div>
                </div>
                <div className="card list-kpi contacts">
                    <div className="list-kpi-body">
                        <div>
                            <p className="list-kpi-label">Phonebooks</p>
                            <h6 className="list-kpi-value">{phonebooks.length}</h6>
                        </div>
                        <div className="list-kpi-icon"><Icon icon="mdi:book-account-outline" /></div>
                    </div>
                </div>
            </div>

            <div className="card basic-data-table list-card">
                <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <div>
                          <h5 className="card-title mb-0">Campaign list</h5>
                          <p className="mb-0 text-secondary-light text-sm">Schedule, queue, and review bulk sends</p>
                        </div>
                        <div>
                            <button
                                type="button"
                                className="btn btn-success text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                                data-bs-toggle={canBulk ? "modal" : undefined}
                                data-bs-target={canBulk ? "#exampleModal" : undefined}
                                disabled={!canBulk}
                                title={canBulk ? "Create campaign" : "Not included in your plan"}
                            >
                                <Icon
                                    icon="ic:baseline-plus"
                                    className="icon text-xl line-height-1"
                                />
                                New campaign
                            </button>
                        </div>
                    </div>
                </div>
                <TableDataLayer
                    columns={columns}
                    totalRows={data}
                    fetchData={fetchCampaigns}
                />
            </div>

            {/* Modal Add Campaign */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                Add New Campaign
                            </h1>
                            <button
                                type="button"
                                id="close-btn"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-24">
                            {
                                alertMessage && (
                                    <div className={`alert alert-${alertMessage.class}`} style={{ fontSize: '12px' }}>
                                        {alertMessage.message}
                                    </div>
                                )
                            }
                            <form onSubmit={handleCampaignSubmit}>
                                <div className="row">
                                    <div className="col-12 mb-20">
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="name"
                                            placeholder="Campaign name"
                                            onChange={(e) => setCampaign({ ...campaign, campaignName: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-12 mb-3">
                                        {/* Instance List */}
                                        <div className="col-12">
                                            <div className="card shadow-sm border-0">
                                                <div className="card-header bg-success-main text-white py-2 d-flex justify-content-between align-items-center">
                                                    <strong className="fs-6">Select Instances</strong>
                                                    {/* Select All inside the header */}
                                                    <div className="form-check m-0 d-flex align-items-center">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="selectAll"
                                                            checked={selectAll}
                                                            onChange={handleSelectAllInstance}
                                                            title="Select All"
                                                        />
                                                        <label className="form-check-label ms-2 small" htmlFor="selectAll">
                                                            Select All
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="card-body px-3 py-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                    {instances.length === 0 ? (
                                                        <div className="text-muted text-center py-3">No instances found</div>
                                                    ) : (
                                                        instances.map((instance) => (
                                                            <div
                                                                className="form-check py-2 px-2 rounded hover-shadow-sm align-items-center d-flex"
                                                                key={instance.id}
                                                                style={{ transition: 'background 0.2s ease' }}
                                                            >
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`instance-${instance.id}`}
                                                                    value={instance.client_id}
                                                                    checked={selectedInstance.includes(instance.client_id)}
                                                                    onChange={() => handleSelectInstance(instance.client_id)}
                                                                />
                                                                <label className="form-check-label ms-2" htmlFor={`instance-${instance.id}`}>
                                                                    {instance.name}
                                                                </label>
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 mb-20">
                                        <input
                                            type="number"
                                            className="form-control radius-8"
                                            id="name"
                                            placeholder="Delay in seconds"
                                            onChange={(e) => setCampaign({ ...campaign, randomDelayTo: e.target.value })}
                                        />
                                    </div>
                                    <ToggleBar
                                        id="switch4"
                                        label="Using template?"
                                        checked={usingTemplate}
                                        onChange={(checked) => setUsingTemplate(checked)}
                                    />
                                    <div className="col-12 mb-20">
                                        {
                                            usingTemplate && (
                                                <div className="form-group">
                                                    <select name="" id="" className="form-select bg-white" value={campaign.templetID} onChange={(e) => setCampaign({ ...campaign, sending_type: "templet", templetID: e.target.value })}>
                                                        <option value="1" disabled selected>
                                                            Select Template
                                                        </option>
                                                        {templates.length > 0 &&
                                                            templates.map((template) => (
                                                                <option key={template.id} value={template.id}>
                                                                    {template.name} | <span>{template.type}</span>
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            )
                                        }
                                        {
                                            !usingTemplate && (
                                                <>
                                                    <textarea className='form-control' placeholder='Type...' value={campaign.message}
                                                        onChange={(e) => setCampaign(prevCampaign => ({
                                                            ...prevCampaign,
                                                            sending_type: 'manual',
                                                            typedMsg: e.target.value,
                                                            message: e.target.value,
                                                            content: { text: e.target.value },
                                                        }))} rows={5}></textarea>
                                                </>
                                            )
                                        }
                                    </div>
                                    <div className="col-12 mb-20">
                                        {
                                            phonebooks.length > 0 && (
                                                <div className="form-group">
                                                    <select name="" id="" className="form-select bg-white" value={campaign.phoneBookName} onChange={(e) => setCampaign({ ...campaign, phoneBookName: e.target.value })}>
                                                        <option value="" disabled selected>
                                                            Select Phonebook
                                                        </option>
                                                        {phonebooks.length > 0 &&
                                                            phonebooks.map((phonebook) => (
                                                                <option key={phonebook.id} value={phonebook.name}>
                                                                    {phonebook.name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            )
                                        }
                                    </div>
                                    {canSchedule ? (
                                        <ToggleBar
                                            id="switch1"
                                            label="Schedule this campaign?"
                                            checked={!!campaign.schedule}
                                            onChange={(checked) =>
                                                setCampaign({
                                                    ...campaign,
                                                    schedule: checked,
                                                    scheduleTimestamp:
                                                        checked && !String(campaign.scheduleTimestamp).includes("T")
                                                            ? moment().format("YYYY-MM-DDTHH:mm")
                                                            : campaign.scheduleTimestamp || moment().format("YYYY-MM-DDTHH:mm"),
                                                })
                                            }
                                        />
                                    ) : (
                                        <p className="text-secondary-light small mb-20">
                                            Scheduled sends are not included in your plan. Campaigns start immediately.
                                        </p>
                                    )}
                                    {
                                        canSchedule && campaign.schedule && (
                                            <>
                                                <div className="col-6 mb-20">
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control radius-8"
                                                        id="schedule-at"
                                                        value={campaign.scheduleTimestamp || ""}
                                                        onChange={(e) => setCampaign({ ...campaign, scheduleTimestamp: e.target.value })}
                                                    />
                                                </div>
                                                <div className="col-6 mb-20">
                                                    <div className="form-group">
                                                        <select
                                                            className="form-select bg-white"
                                                            value={campaign.timezone}
                                                            onChange={(e) => setCampaign({ ...campaign, timezone: e.target.value })}
                                                        >
                                                            <option value="" disabled>
                                                                Select Zone
                                                            </option>
                                                            {(timeZones || []).map((zone) => (
                                                                <option key={zone} value={zone}>
                                                                    {zone}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }
                                    <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                                        <button
                                            type="reset"
                                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                                        >
                                            Reset
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success border border-success-600 text-md px-24 py-12 radius-8"
                                        >
                                            Save Change
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CampaignLayer